import { motion } from "framer-motion";
import ecommerceIcon from "./assets/effi.svg";
import transportIcon from "./assets/res.svg";
import healthcareIcon from "./assets/comp.svg";
import agricultureIcon from "./assets/emp.svg";
import constructionIcon from "./assets/sat.svg";
import rentalIcon from "./assets/da.svg";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.25,
    },
  },
};

const TimeBenefits = () => {
  const industries = [
    {
      id: "efficiency",
      icon: ecommerceIcon,
      title: "Efficiency",
      desc: "All functions are intuitive, easy to navigate, manage, and enhance overall efficiency",
    },
    {
      id: "accuracy",
      icon: transportIcon,
      title: "Accuracy",
      desc: "Automated capture of punch data ensures no mistakes in attendance capture",
    },
    {
      id: "automation",
      icon: healthcareIcon,
      title: "Automation",
      desc: "Exceptions are automatically identified, and responsible persons are automatically alerted",
    },
    {
      id: "safety",
      icon: agricultureIcon,
      title: "Safety",
      desc: "With punch data, visibility of attendance is available immediately in case of emergency",
    },
    {
      id: "employee-satisfaction",
      icon: constructionIcon,
      title: "Employee Satisfaction",
      desc: "Accurate attendance capture ensures compensation-based allowances like incentives and overtime are computed correctly",
    },
    {
      id: "data-analysis",
      icon: rentalIcon,
      title: "Data Analysis",
      desc: "Accurate data availability supports reporting as well as auditing purposes",
    },
  ];

  return (
    <section className="w-full py-16 font-epilogue bg-white">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-gray-900"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          How it benefits your organization?
        </motion.h2>
        <motion.p
          className="mt-4 text-gray-600 max-w-2xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          Discover more JIVIEWS features
        </motion.p>
        <motion.div
          className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          {industries.map((item) => (
            <motion.div
              key={item.id}   
              variants={fadeUp}
              className="relative group bg-white rounded-lg p-6 transition-all duration-300 hover:shadow-xl"
            >
              <span className="absolute top-0 left-0 w-0 h-[2px] bg-[#1E72BB] group-hover:w-full transition-all duration-500"></span>
              <span className="absolute top-0 right-0 w-[2px] h-0 bg-[#1E72BB] group-hover:h-full transition-all duration-500 delay-100"></span>
              <span className="absolute bottom-0 right-0 w-0 h-[2px] bg-[#1E72BB] group-hover:w-full transition-all duration-500 delay-200"></span>
              <span className="absolute bottom-0 left-0 w-[2px] h-0 bg-[#1E72BB] group-hover:h-full transition-all duration-500 delay-300"></span>
              <motion.div
                className="w-15 h-15 flex items-center justify-center rounded-full mb-4 mx-auto"
                whileHover={{ scale: 1.1 }}
                transition={{ type: "spring", stiffness: 300, damping: 12 }}
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  className="w-10 h-10 transition-transform duration-300 group-hover:scale-110"
                />
              </motion.div>
              <h3 className="text-lg font-semibold text-gray-900">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-gray-600">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TimeBenefits;
